<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		:viewBox="iconName === 'Alcohol' ? '0 0 90 90' : '0 0 57 57'"
		:aria-labelledby="id"
		:class="{ alcoholSvg: iconName === 'Alcohol' }"
		role="presentation"
	>
		<title :id="id" lang="en">{{ iconName }}</title>
		<g :fill="iconColor">
			<slot />
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		id: {
			type: [String, Number],
			default: ""
		},
		iconName: {
			type: String,
			default: "box"
		},
		width: {
			type: [Number, String],
			default: 18
		},
		height: {
			type: [Number, String],
			default: 18
		},
		iconColor: {
			type: String,
			default: "currentColor"
		}
	}
};
</script>

<style>
.alcoholSvg {
	width: 80px !important;
	height: 80px !important;
}
</style>